<div
  class="tw-flex tw-w-full tw-cursor-pointer tw-bg-dt-surface-card tw-border-0 tw-border-l-[3px] tw-border-accent tw-px-4 tw-py-3"
  (click)="toggleExpand($event)"
>
  <div class="tw-flex tw-w-full tw-items-center tw-justify-between">
    <div class="tw-flex tw-flex-col">
      <span class="tw-text-dt-surface-past-primary tw-text-[16px] tw-font-medium">{{
        groupLabel
      }}</span>
      @if (count > 0) {
        <span class="tw-text-[13px] tw-text-dt-text-secondary"
          >{{ count }} {{ (count === 1 ? "transaction" : "transactions") | i18n }}</span
        >
      }
    </div>
    <div class="tw-flex tw-gap-3 tw-items-center">
      <!-- grocery plugin indicator -->
      @if (hasGroceryTransaction) {
        <svg
          width="18"
          height="18"
          viewBox="0 0 24 24"
          class="tw-shrink-0 tw-text-color-status-warning-icon tw-cursor-default"
          role="img"
          [attr.aria-label]="'containsGroceryTransactions' | i18n"
        >
          <use href="images/sprite.svg#info-tooltip" />
        </svg>
      }
      <div class="tw-flex tw-flex-col tw-items-end tw-px-2 tw-py-1">
        <!--        balance-->
        <span class="tw-capitalize tw-text-[13px] tw-text-dt-text-secondary">{{
          "closingBal" | i18n
        }}</span>
        <div>
          <span
            [ngClass]="groupBalanceClass"
            class="tw-text-[16px] tw-font-medium tw-font-D-DIN-PRO"
            >{{ formattedGroupBalance }}</span
          >
          <span class="tw-text-sm tw-font-medium tw-text-dt-text-tertiary tw-uppercase">
            {{ groupCurrency }}
          </span>
        </div>
      </div>
      <!-- right icon: one arrow, turned when the group is open -->
      <div class="past-group-chevron" [class.is-open]="isExpanded">
        @if (isExpandable) {
          <icon [name]="'down-arrow'" [size]="6" [currentColor]="'neutral-800'"></icon>
        }
      </div>
    </div>
  </div>
</div>
